export const PFCharacterData = [
  {
    name: 'Acheron',
    char: 'acheron',
    current_app_rate: 32.69,
    app_eidolons: 21.69,
    app_free: 1.52,
    current_avg_score: 29179,
    round_eidolons: 33226,
    round_free: 27164,
    prev_app_rate: 54.61,
    prev_avg_score: 33030,
    rarity: 'Limited 5*'
  },
  {
    name: 'Aglaea',
    char: 'aglaea',
    current_app_rate: 14.02,
    app_eidolons: 8,
    app_free: 2.06,
    current_avg_score: 31810,
    round_eidolons: 38214,
    round_free: 30211,
    prev_app_rate: 4.08,
    prev_avg_score: 30909,
    rarity: 'Limited 5*'
  },
  {
    name: 'Argenti',
    char: 'argenti',
    current_app_rate: 5.19,
    app_eidolons: 2.54,
    app_free: 1.24,
    current_avg_score: 34458,
    round_eidolons: 38666,
    round_free: 34047,
    prev_app_rate: 10.92,
    prev_avg_score: 32831,
    rarity: 'Limited 5*'
  },
  {
    name: 'Arlan',
    char: 'arlan',
    current_app_rate: 0.01,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Asta',
    char: 'asta',
    current_app_rate: 0.08,
    app_eidolons: 0.03,
    app_free: 0.03,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.16,
    prev_avg_score: 26932,
    rarity: '4*'
  },
  {
    name: 'Aventurine',
    char: 'aventurine',
    current_app_rate: 46.23,
    app_eidolons: 24.1,
    app_free: 8.03,
    current_avg_score: 33900,
    round_eidolons: 37036,
    round_free: 34092,
    prev_app_rate: 52.89,
    prev_avg_score: 33907,
    rarity: 'Limited 5*'
  },
  {
    name: 'Bailu',
    char: 'bailu',
    current_app_rate: 0.57,
    app_eidolons: 0.38,
    app_free: 0.05,
    current_avg_score: 32110,
    round_eidolons: 32174,
    round_free: 0,
    prev_app_rate: 0.6,
    prev_avg_score: 29253,
    rarity: 'Standard 5*'
  },
  {
    name: 'Black Swan',
    char: 'black-swan',
    current_app_rate: 5.18,
    app_eidolons: 3.45,
    app_free: 0.24,
    current_avg_score: 24474,
    round_eidolons: 26669,
    round_free: 24513,
    prev_app_rate: 13.93,
    prev_avg_score: 28965,
    rarity: 'Limited 5*'
  },
  {
    name: 'Blade',
    char: 'blade',
    current_app_rate: 0.83,
    app_eidolons: 0.56,
    app_free: 0.11,
    current_avg_score: 31444,
    round_eidolons: 32419,
    round_free: 31365,
    prev_app_rate: 0.44,
    prev_avg_score: 26658,
    rarity: 'Limited 5*'
  },
  {
    name: 'Boothill',
    char: 'boothill',
    current_app_rate: 0.07,
    app_eidolons: 0.06,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.13,
    prev_avg_score: 0,
    rarity: 'Limited 5*'
  },
  {
    name: 'Bronya',
    char: 'bronya',
    current_app_rate: 3.44,
    app_eidolons: 2.58,
    app_free: 0.28,
    current_avg_score: 29313,
    round_eidolons: 33243,
    round_free: 27667,
    prev_app_rate: 3.81,
    prev_avg_score: 28850,
    rarity: 'Standard 5*'
  },
  {
    name: 'Clara',
    char: 'clara',
    current_app_rate: 1.15,
    app_eidolons: 0.66,
    app_free: 0.3,
    current_avg_score: 27597,
    round_eidolons: 31757,
    round_free: 27732,
    prev_app_rate: 3.23,
    prev_avg_score: 24621,
    rarity: 'Standard 5*'
  },
  {
    name: 'Dan Heng',
    char: 'dan-heng',
    current_app_rate: 0.01,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Dr. Ratio',
    char: 'dr-ratio',
    current_app_rate: 0.05,
    app_eidolons: 0.05,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.03,
    prev_avg_score: 0,
    rarity: 'Limited 5*'
  },
  {
    name: 'Feixiao',
    char: 'feixiao',
    current_app_rate: 3.13,
    app_eidolons: 2.24,
    app_free: 0.33,
    current_avg_score: 28683,
    round_eidolons: 33787,
    round_free: 27230,
    prev_app_rate: 2.74,
    prev_avg_score: 25919,
    rarity: 'Limited 5*'
  },
  {
    name: 'Firefly',
    char: 'firefly',
    current_app_rate: 15.38,
    app_eidolons: 13.42,
    app_free: 0.8,
    current_avg_score: 25590,
    round_eidolons: 32934,
    round_free: 25264,
    prev_app_rate: 13.14,
    prev_avg_score: 25585,
    rarity: 'Limited 5*'
  },
  {
    name: 'Fu Xuan',
    char: 'fu-xuan',
    current_app_rate: 20.76,
    app_eidolons: 12.91,
    app_free: 2.59,
    current_avg_score: 32578,
    round_eidolons: 34200,
    round_free: 33364,
    prev_app_rate: 28.75,
    prev_avg_score: 32402,
    rarity: 'Limited 5*'
  },
  {
    name: 'Gallagher',
    char: 'gallagher',
    current_app_rate: 21.94,
    app_eidolons: 10.24,
    app_free: 5.37,
    current_avg_score: 32241,
    round_eidolons: 33186,
    round_free: 32224,
    prev_app_rate: 25.08,
    prev_avg_score: 33063,
    rarity: '4*'
  },
  {
    name: 'Gepard',
    char: 'gepard',
    current_app_rate: 0.73,
    app_eidolons: 0.47,
    app_free: 0.05,
    current_avg_score: 25537,
    round_eidolons: 27251,
    round_free: 0,
    prev_app_rate: 1.85,
    prev_avg_score: 28990,
    rarity: 'Standard 5*'
  },
  {
    name: 'Guinaifen',
    char: 'guinaifen',
    current_app_rate: 0.14,
    app_eidolons: 0.04,
    app_free: 0.03,
    current_avg_score: 23977,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.58,
    prev_avg_score: 26709,
    rarity: '4*'
  },
  {
    name: 'Hanya',
    char: 'hanya',
    current_app_rate: 0.07,
    app_eidolons: 0.03,
    app_free: 0.03,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.12,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Herta',
    char: 'herta',
    current_app_rate: 61.26,
    app_eidolons: 24.87,
    app_free: 18.06,
    current_avg_score: 37921,
    round_eidolons: 39310,
    round_free: 36796,
    prev_app_rate: 64.31,
    prev_avg_score: 34405,
    rarity: '4*'
  },
  {
    name: 'Himeko',
    char: 'himeko',
    current_app_rate: 8.56,
    app_eidolons: 4.68,
    app_free: 2.35,
    current_avg_score: 29766,
    round_eidolons: 33251,
    round_free: 28850,
    prev_app_rate: 10.7,
    prev_avg_score: 26256,
    rarity: 'Standard 5*'
  },
  {
    name: 'Hook',
    char: 'hook',
    current_app_rate: 0.01,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Huohuo',
    char: 'huohuo',
    current_app_rate: 26.73,
    app_eidolons: 13.88,
    app_free: 5.39,
    current_avg_score: 33974,
    round_eidolons: 37998,
    round_free: 33458,
    prev_app_rate: 27.75,
    prev_avg_score: 33537,
    rarity: 'Limited 5*'
  },
  {
    name: 'Imbibitor Lunae',
    char: 'imbibitor-lunae',
    current_app_rate: 1.03,
    app_eidolons: 1,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 30387,
    round_free: 0,
    prev_app_rate: 0.39,
    prev_avg_score: 0,
    rarity: 'Limited 5*'
  },
  {
    name: 'Jade',
    char: 'jade',
    current_app_rate: 29.01,
    app_eidolons: 14.18,
    app_free: 6.9,
    current_avg_score: 39346,
    round_eidolons: 40000,
    round_free: 38730,
    prev_app_rate: 26,
    prev_avg_score: 37279,
    rarity: 'Limited 5*'
  },
  {
    name: 'Jiaoqiu',
    char: 'jiaoqiu',
    current_app_rate: 19.27,
    app_eidolons: 12.64,
    app_free: 0.95,
    current_avg_score: 30345,
    round_eidolons: 35058,
    round_free: 27889,
    prev_app_rate: 26.92,
    prev_avg_score: 38448,
    rarity: 'Limited 5*'
  },
  {
    name: 'Jing Yuan',
    char: 'jing-yuan',
    current_app_rate: 12.85,
    app_eidolons: 7.51,
    app_free: 1.5,
    current_avg_score: 29448,
    round_eidolons: 33423,
    round_free: 27901,
    prev_app_rate: 13.6,
    prev_avg_score: 30614,
    rarity: 'Limited 5*'
  },
  {
    name: 'Jingliu',
    char: 'jingliu',
    current_app_rate: 0.31,
    app_eidolons: 0.26,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 25893,
    round_free: 0,
    prev_app_rate: 0.61,
    prev_avg_score: 23795,
    rarity: 'Limited 5*'
  },
  {
    name: 'Kafka',
    char: 'kafka',
    current_app_rate: 6.8,
    app_eidolons: 4.37,
    app_free: 0.43,
    current_avg_score: 25192,
    round_eidolons: 29056,
    round_free: 25246,
    prev_app_rate: 17.13,
    prev_avg_score: 30197,
    rarity: 'Limited 5*'
  },
  {
    name: 'Lingsha',
    char: 'lingsha',
    current_app_rate: 39.11,
    app_eidolons: 21.58,
    app_free: 7.7,
    current_avg_score: 34835,
    round_eidolons: 37889,
    round_free: 33960,
    prev_app_rate: 39.33,
    prev_avg_score: 34535,
    rarity: 'Limited 5*'
  },
  {
    name: 'Luka',
    char: 'luka',
    current_app_rate: 0.01,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Luocha',
    char: 'luocha',
    current_app_rate: 8.82,
    app_eidolons: 4.52,
    app_free: 1.83,
    current_avg_score: 32458,
    round_eidolons: 33958,
    round_free: 32108,
    prev_app_rate: 8.25,
    prev_avg_score: 32310,
    rarity: 'Limited 5*'
  },
  {
    name: 'Lynx',
    char: 'lynx',
    current_app_rate: 0.45,
    app_eidolons: 0.23,
    app_free: 0.06,
    current_avg_score: 28861,
    round_eidolons: 33452,
    round_free: 0,
    prev_app_rate: 0.52,
    prev_avg_score: 25214,
    rarity: '4*'
  },
  {
    name: 'March 7th',
    char: 'march-7th',
    current_app_rate: 0.19,
    app_eidolons: 0.11,
    app_free: 0.01,
    current_avg_score: 31413,
    round_eidolons: 34979,
    round_free: 0,
    prev_app_rate: 0.55,
    prev_avg_score: 33180,
    rarity: '4*'
  },
  {
    name: 'March 7th - The Hunt',
    char: 'march-7th-swordmaster',
    current_app_rate: 0.56,
    app_eidolons: 0.31,
    app_free: 0.17,
    current_avg_score: 24778,
    round_eidolons: 29786,
    round_free: 24717,
    prev_app_rate: 0.56,
    prev_avg_score: 24378,
    rarity: '4*'
  },
  {
    name: 'Misha',
    char: 'misha',
    current_app_rate: 0.01,
    app_eidolons: 0.01,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Moze',
    char: 'moze',
    current_app_rate: 0.11,
    app_eidolons: 0.07,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 30540,
    round_free: 0,
    prev_app_rate: 0.04,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Mydei',
    char: 'mydei',
    current_app_rate: 3.45,
    app_eidolons: 2.42,
    app_free: 0.19,
    current_avg_score: 27310,
    round_eidolons: 34719,
    round_free: 25867,
    prev_app_rate: 2.83,
    prev_avg_score: 26934,
    rarity: 'Limited 5*'
  },
  {
    name: 'Natasha',
    char: 'natasha',
    current_app_rate: 0.03,
    app_eidolons: 0.03,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.08,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Pela',
    char: 'pela',
    current_app_rate: 13.34,
    app_eidolons: 7.06,
    app_free: 0.98,
    current_avg_score: 28907,
    round_eidolons: 31498,
    round_free: 27826,
    prev_app_rate: 22.25,
    prev_avg_score: 33457,
    rarity: '4*'
  },
  {
    name: 'Qingque',
    char: 'qingque',
    current_app_rate: 0.43,
    app_eidolons: 0.29,
    app_free: 0.07,
    current_avg_score: 26326,
    round_eidolons: 30639,
    round_free: 27280,
    prev_app_rate: 0.1,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Rappa',
    char: 'rappa',
    current_app_rate: 15.89,
    app_eidolons: 6.63,
    app_free: 4.37,
    current_avg_score: 31236,
    round_eidolons: 37321,
    round_free: 29453,
    prev_app_rate: 5.45,
    prev_avg_score: 29364,
    rarity: 'Limited 5*'
  },
  {
    name: 'Robin',
    char: 'robin',
    current_app_rate: 45.97,
    app_eidolons: 26.67,
    app_free: 7.44,
    current_avg_score: 32321,
    round_eidolons: 37200,
    round_free: 31740,
    prev_app_rate: 52.85,
    prev_avg_score: 32973,
    rarity: 'Limited 5*'
  },
  {
    name: 'Ruan Mei',
    char: 'ruan-mei',
    current_app_rate: 44.66,
    app_eidolons: 27.43,
    app_free: 8.48,
    current_avg_score: 31070,
    round_eidolons: 33825,
    round_free: 30077,
    prev_app_rate: 36.49,
    prev_avg_score: 29825,
    rarity: 'Limited 5*'
  },
  {
    name: 'Sampo',
    char: 'sampo',
    current_app_rate: 0.04,
    app_eidolons: 0.02,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.07,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Seele',
    char: 'seele',
    current_app_rate: 0.32,
    app_eidolons: 0.28,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 29461,
    round_free: 0,
    prev_app_rate: 0.17,
    prev_avg_score: 0,
    rarity: 'Limited 5*'
  },
  {
    name: 'Serval',
    char: 'serval',
    current_app_rate: 7.8,
    app_eidolons: 3.62,
    app_free: 1.91,
    current_avg_score: 37631,
    round_eidolons: 39983,
    round_free: 36648,
    prev_app_rate: 4.97,
    prev_avg_score: 32781,
    rarity: '4*'
  },
  {
    name: 'Silver Wolf',
    char: 'silver-wolf',
    current_app_rate: 1.18,
    app_eidolons: 0.72,
    app_free: 0.04,
    current_avg_score: 24021,
    round_eidolons: 25475,
    round_free: 0,
    prev_app_rate: 3.71,
    prev_avg_score: 26768,
    rarity: 'Limited 5*'
  },
  {
    name: 'Sparkle',
    char: 'sparkle',
    current_app_rate: 12.66,
    app_eidolons: 10.16,
    app_free: 0.76,
    current_avg_score: 28929,
    round_eidolons: 33007,
    round_free: 29123,
    prev_app_rate: 20.32,
    prev_avg_score: 30402,
    rarity: 'Limited 5*'
  },
  {
    name: 'Sunday',
    char: 'sunday',
    current_app_rate: 40.6,
    app_eidolons: 23.84,
    app_free: 4.47,
    current_avg_score: 31449,
    round_eidolons: 34948,
    round_free: 30037,
    prev_app_rate: 40.31,
    prev_avg_score: 32866,
    rarity: 'Limited 5*'
  },
  {
    name: 'Sushang',
    char: 'sushang',
    current_app_rate: 0,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'The Herta',
    char: 'the-herta',
    current_app_rate: 71.67,
    app_eidolons: 28.43,
    app_free: 19.82,
    current_avg_score: 39299,
    round_eidolons: 40000,
    round_free: 38587,
    prev_app_rate: 71.04,
    prev_avg_score: 37703,
    rarity: 'Limited 5*'
  },
  {
    name: 'Tingyun',
    char: 'tingyun',
    current_app_rate: 2.37,
    app_eidolons: 1.22,
    app_free: 0.54,
    current_avg_score: 28640,
    round_eidolons: 31634,
    round_free: 28208,
    prev_app_rate: 5.24,
    prev_avg_score: 29152,
    rarity: '4*'
  },
  {
    name: 'Fugue',
    char: 'tingyun-fugue',
    current_app_rate: 30.77,
    app_eidolons: 19.59,
    app_free: 5.42,
    current_avg_score: 30962,
    round_eidolons: 34704,
    round_free: 29524,
    prev_app_rate: 23.58,
    prev_avg_score: 29670,
    rarity: 'Limited 5*'
  },
  {
    name: 'Topaz & Numby',
    char: 'topaz',
    current_app_rate: 0.56,
    app_eidolons: 0.46,
    app_free: 0.02,
    current_avg_score: 24877,
    round_eidolons: 31444,
    round_free: 0,
    prev_app_rate: 0.76,
    prev_avg_score: 24289,
    rarity: 'Limited 5*'
  },
  {
    name: 'Trailblazer - Destruction',
    char: 'trailblazer-destruction',
    current_app_rate: 0,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Trailblazer - Harmony',
    char: 'trailblazer-harmony',
    current_app_rate: 11.52,
    app_eidolons: 6.95,
    app_free: 2.24,
    current_avg_score: 30347,
    round_eidolons: 33081,
    round_free: 29163,
    prev_app_rate: 5.45,
    prev_avg_score: 25113,
    rarity: '4*'
  },
  {
    name: 'Trailblazer - Preservation',
    char: 'trailblazer-preservation',
    current_app_rate: 0.04,
    app_eidolons: 0.03,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.06,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Trailblazer - Remembrance',
    char: 'trailblazer-remembrance',
    current_app_rate: 41.03,
    app_eidolons: 16.03,
    app_free: 12.1,
    current_avg_score: 36761,
    round_eidolons: 38597,
    round_free: 34634,
    prev_app_rate: 41.54,
    prev_avg_score: 37346,
    rarity: '4*'
  },
  {
    name: 'Tribbie',
    char: 'tribbie',
    current_app_rate: 64.84,
    app_eidolons: 33.86,
    app_free: 14.09,
    current_avg_score: 39633,
    round_eidolons: 40000,
    round_free: 39358,
    prev_app_rate: 6.75,
    prev_avg_score: 39565,
    rarity: 'Limited 5*'
  },
  {
    name: 'Welt',
    char: 'welt',
    current_app_rate: 0.07,
    app_eidolons: 0.05,
    app_free: 0.01,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.3,
    prev_avg_score: 24283,
    rarity: 'Standard 5*'
  },
  {
    name: 'Xueyi',
    char: 'xueyi',
    current_app_rate: 0.28,
    app_eidolons: 0.2,
    app_free: 0.06,
    current_avg_score: 30527,
    round_eidolons: 31170,
    round_free: 0,
    prev_app_rate: 0.1,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Yanqing',
    char: 'yanqing',
    current_app_rate: 0,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0,
    prev_avg_score: 0,
    rarity: 'Standard 5*'
  },
  {
    name: 'Yukong',
    char: 'yukong',
    current_app_rate: 0,
    app_eidolons: 0,
    app_free: 0,
    current_avg_score: 0,
    round_eidolons: 0,
    round_free: 0,
    prev_app_rate: 0.01,
    prev_avg_score: 0,
    rarity: '4*'
  },
  {
    name: 'Yunli',
    char: 'yunli',
    current_app_rate: 4.54,
    app_eidolons: 2.74,
    app_free: 0.65,
    current_avg_score: 31229,
    round_eidolons: 37583,
    round_free: 29869,
    prev_app_rate: 5.26,
    prev_avg_score: 25944,
    rarity: 'Limited 5*'
  }
];
